import React from 'react';
/* eslint-disable */
export function TextAlignment(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.875 14.125H4.375C3.88281 14.125 3.5 14.5352 3.5 15C3.5 15.4922 3.88281 15.875 4.375 15.875H14.875C15.3398 15.875 15.75 15.4922 15.75 15C15.75 14.5352 15.3398 14.125 14.875 14.125ZM4.375 8.875H14.875C15.3398 8.875 15.75 8.49219 15.75 8C15.75 7.53516 15.3398 7.125 14.875 7.125H4.375C3.88281 7.125 3.5 7.53516 3.5 8C3.5 8.49219 3.88281 8.875 4.375 8.875ZM4.375 5.375H10.5C10.9648 5.375 11.375 4.99219 11.375 4.5C11.375 4.03516 10.9648 3.625 10.5 3.625H4.375C3.88281 3.625 3.5 4.03516 3.5 4.5C3.5 4.99219 3.88281 5.375 4.375 5.375ZM4.375 12.375H10.5C10.9648 12.375 11.375 11.9922 11.375 11.5C11.375 11.0352 10.9648 10.625 10.5 10.625H4.375C3.88281 10.625 3.5 11.0352 3.5 11.5C3.5 11.9922 3.88281 12.375 4.375 12.375Z"
        fill="currentColor"
      />
    </svg>
  );
}
